// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 40px;
`;

export class SectionRow extends React.Component {
  render() {
    return <Container>{this.props.children}</Container>;
  }
}

export default SectionRow;



// WEBPACK FOOTER //
// ./src/components/common/SectionRow/index.js